export default __webpack_public_path__ + "static/media/Haimadipsa.4e6523b5.png";